/*
 * CODE GENERATED AUTOMATICALLY WITH GraphQL Codegen
 * THIS FILE SHOULD NOT BE EDITED MANUALLY.
 */
import {
  BaseQueryModel,
  IQueryModelOpts,
  useQuery,
  useGqlClient,
} from '@r-client/shared/data/client';
import {
  ILiveSectorTagsQuery,
  ILiveSectorTagsQueryVariables,
  LiveSectorTagsDocument,
} from './types';
import { ITagsTagConnection } from '@r-client/data/graphql-types';
export type { ITagsTagConnection };

export type ILiveSectorTagsQueryOpts =
  IQueryModelOpts<ILiveSectorTagsQueryVariables>;

export class LiveSectorTagsQuery extends BaseQueryModel<
  ILiveSectorTagsQuery,
  ILiveSectorTagsQueryVariables
> {
  // This is fine. Here we explicitly change interface for query
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(opts: ILiveSectorTagsQueryOpts) {
    super(opts);
  }

  get query() {
    return LiveSectorTagsDocument;
  }
}
export function useLiveSectorTagsQuery(
  opts?: Omit<ILiveSectorTagsQueryOpts, 'client'>
) {
  const client = useGqlClient();
  return useQuery(
    () => new LiveSectorTagsQuery({ ...opts, client }),
    opts?.variables
  );
}
